const overtimeEntry = {
  id: null,
  assignmentId: null,
  date: null,
  OTPayRate: null,
  OTBillRate: null,
  hours: null
}

export default () => Object.assign({}, overtimeEntry)
